import Crud from '@/services/Crud'

const newsletters = new Crud('Newsletters')

export default newsletters
